import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { TWaitingRoomMeetingData } from '.';

export type TGetWaitingRoomMeetingDataByWaitingId = {
  waitingId: string;
};

export type TStartMeeting = {
  sectionId: string;
};

export type TNotifyUserJoinedToMeeting = {
  waitingId: string;
  sendNotification?: boolean;
};

export type TNotifyUserWaiting = {
  waitingId: string;
};

const apiDataProvider = new APIDataProvider();

const getWaitingRoomMeetingDataByWaitingIdModule = async (
  data: TGetWaitingRoomMeetingDataByWaitingId
) => {
  const path = `${ApiPaths.waitingRoom}/meeting-data/${data.waitingId}`;

  const response = await apiDataProvider.get<
    TApiResponse<TWaitingRoomMeetingData>
  >(path);

  return response.data;
};

export const getWaitingRoomMeetingDataByWaitingId = createAsyncThunk(
  '/waiting-room/meeting-data/waitingId',
  getWaitingRoomMeetingDataByWaitingIdModule
);

export const getWaitingRoomMeetingDataByWaitingIdInBackground = createAsyncThunk(
  '/waiting-room/meeting-data/waitingId/in-background',
  getWaitingRoomMeetingDataByWaitingIdModule
);

export const startMeeting = createAsyncThunk(
  '/waiting-room/start-meeting',
  async (data: TStartMeeting) => {
    const path = `${ApiPaths.waitingRoom}/start-meeting`;

    const response = await apiDataProvider.post<
      TApiResponse<TWaitingRoomMeetingData>
    >(path, data);

    return response.data;
  }
);

export const notifyUserJoinedToMeeting = createAsyncThunk(
  '/waiting-room/notify-user-joined-to-meeting',
  async (data: TNotifyUserJoinedToMeeting) => {
    const path = `${ApiPaths.waitingRoom}/notify-user-joined-to-meeting`;

    const response = await apiDataProvider.post<
      TApiResponse<TWaitingRoomMeetingData>
    >(path, data);

    return response.data;
  }
);

export const notifyUserWaiting = createAsyncThunk(
  '/waiting-room/notify-user-waiting',
  async (data: TNotifyUserWaiting) => {
    const path = `${ApiPaths.waitingRoom}/notify-user-waiting`;

    const response = await apiDataProvider.post<
      TApiResponse<{ message: string }>
    >(path, data);

    return response.data;
  }
);
